import { render, staticRenderFns } from "./change-unit-identifier.vue?vue&type=template&id=e381867e&"
import script from "./js/change-unit-identifier.js?vue&type=script&lang=js&"
export * from "./js/change-unit-identifier.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports